import React from 'react';
import T from 'prop-types';
import { Title } from "../../atoms";
import { Tooltip } from '@mui/material';
import Fade from '@mui/material/Fade';

export const MenuItem = ({ text, active, icon, link,desktop }) => {
    return <a className={'menuCls'}  href={link} style={{fontSize:desktop &&'0px'}}>
       
         <Tooltip 
          TransitionComponent={Fade}
          TransitionProps={{ timeout: 0 }}
          componentsProps={{
            tooltip: {
            sx: {
                bgcolor:!active?'#E3031F': '#fff',
                fontSize: '.9rem',
                borderRadius:'0px 5px 5px 0px',
                 boxShadow: '1px 0px 1px 1px rgba(227, 3, 31, 0.1)',
                marginLeft:'-50px',
                padding:'10px',
                '& .MuiTooltip-arrow': {
                color: '#E3031F',
                width:'0px',
                },
            },
            },
        }}

        slotProps={{
            popper: {
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [-2,active? -18:-5],
                  },
                },
              ],
            },
        }}
         
         title={<React.Fragment><h4 style={{lineHeight:'22px'}} className={[active?'red':'white', active ? 'space-left':'space-left2'].join(' ')}>{text}</h4></React.Fragment>} placement="left-start" >
             <div className={[active?'tn1':'tn2','center'].join(' ')}>
            {React.cloneElement(icon, { color : active ? '#E3031F' : '#666666', size: 20,margin:'auto'})}
            </div>
          
        </Tooltip>
       
        <Title text={text} className={active ? "menuTextActive" : "menuTextCls"} />
    </a>;
};

Title.T = {
    text: T.string,
    active: T.bool,
};

Title.defaultProps = {
    active: false
};
